import 'Components/AppComponents/Board/BoardLayout.css';
// import AspectRatio from 'Components/GenericComponents/AspectRatio/AspectRatio';
import React from 'react';

type BoardLayoutProps = {
    children: React.ReactNode;
};

const BoardLayout = ({ children }: BoardLayoutProps) => {
    return (
        <div id='board-layout' className="set-min-max-width m-auto w-full h-full duration-1000">
            <div
                className="relative overflow-hidden m-auto w-full board-div blur-8"
                style={{
                    background: `url(/images/Background.png) no-repeat center`,
                    backgroundSize: 'cover',                    
                    backgroundColor: '#39b54a',
                    maxWidth: '1200px',
                    minWidth: '1200px',
                    minHeight: '776.493px',
                    maxHeight: '776.493px',
                }}
            >
                {children}
            </div> 
        </div>
    );
};

export default BoardLayout;
